"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconUiOrderHistory = function IconUiOrderHistory(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return _react.default.createElement("svg", _extends({
    className: (0, _classnames.default)(className, 'svg-icon'),
    viewBox: "0 0 48 48"
  }, props), _react.default.createElement("path", {
    d: "M34.014 18.5a11.207 11.207 0 0 0-8.971 4.5H15v2h8.842a11.136 11.136 0 0 0 .266 10H15v2h10.478a11.223 11.223 0 1 0 8.536-18.5zm0 20.455a9.228 9.228 0 1 1 9.227-9.227 9.239 9.239 0 0 1-9.227 9.224z"
  }), _react.default.createElement("path", {
    d: "M34.891 23.211h-2v6.919l4.547 4.729 1.441-1.385-3.988-4.149v-6.114zM15 11h29v2H15z"
  }), _react.default.createElement("circle", {
    cx: 7,
    cy: 24.03,
    r: 3
  }), _react.default.createElement("circle", {
    cx: 7,
    cy: 12,
    r: 3
  }), _react.default.createElement("circle", {
    cx: 7,
    cy: 36,
    r: 3
  }));
};

IconUiOrderHistory.propTypes = {
  className: _propTypes.default.string
};
var _default = IconUiOrderHistory;
exports.default = _default;